export default {
    routeCount: 0,
    loading: false,
    calculatorModel: false,
    alert: {
        active: false,
        color: "",
        text: "",
        icon: ""
    },
    user: null,
    veterinaryColleges: [],
    isDrugsManagement: false,
    userSection: false,
    link_redirect: null,
    confirmModel: {
        active: false,
        text: "",
        action: "",
        confirmText: "",
        closeText: "",
        parameters: null
    },
    confirmOpenOnApp: false,
    stepper: 1,
    stepperTotal: 1,
    stepperData: [],
    stepperModel: true,
    homeAdds: null,
    postActivity: null,
    emailConfirmation: false,
    breadcrumbs: [],
    synonyms: [],
    sectionsPanelOpen: false
}